import {useCallback, useRef, useEffect} from 'react';

import Rpc from 'core-libs/backbone.rpc';

type ReturnData =
	| Record<string, any>
	| Record<string, any>[]
	| string[]
	| string;

type Data = Array<number | string | Record<string, any>> | Record<string, any>;

/**
 * @deprecated Just convert whatever api call over to our new api standard - this was a holdover for utilizing backbone rpc
 */
export default function useRpc() {
	const rpcRef = useRef<Rpc>();
	const lastMethod = useRef<string>();

	useEffect(() => {
		const rpc = (rpcRef.current = new Rpc());
		rpc.duplicateQueryPolicy = 'abort';
		return (): void => {
			if (rpc && lastMethod.current) {
				const request = rpc.callsByName && rpc.callsByName[lastMethod.current];
				if (request && request.xhr?.state && request.xhr.state() == 'pending') {
					request.xhr.abort && request.xhr.abort();
				}
			}
			rpcRef.current = undefined;
		};
	}, []);

	const query = useCallback(
		<TReturn extends ReturnData>(
			method: string,
			data?: Data,
		): Promise<TReturn> => {
			lastMethod.current = method;
			return new Promise((resolve, reject) => {
				if (!rpcRef.current || !rpcRef.current.query) return;
				rpcRef.current
					.query(method, data || [], (result: TReturn) => {
						lastMethod.current = undefined;
						return resolve(result);
					})
					.catch(reject);
			});
		},
		[],
	);

	return query;
}
